import axios from './_inveAxios'

export const obtenerDetallesxIdOrdenAsInfoMovimientosPresupuesto = id =>
  axios.get(`/ordenes-compra/${id}/detalles`, {
    params: {
      tipoConsulta: 'movimiento-presupuesto'
    }
  })

export const obtenerxIdSocioAsMovimientosPresupuesto = idSocio =>
  axios.get('/ordenes-compra', {
    params: {
      tipoConsulta: 'movimiento-presupuesto',
      idSocio: idSocio
    }
  })
